import {connect} from 'react-redux';

import App from '../components/App';
import {auto_login, login_out, user_update} from '../redux/actions';

export default connect((state)=>{
    return {
        user  : state.Login
    }
}, {
    auto_login, 
    login_out,
    user_update
})(App)